import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f52c00b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "fw-bold mb-3" }
const _hoisted_5 = { class: "text-muted mb-2" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Auteur :", -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 2,
  class: "text-danger"
}

import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import ApiService from "@/services/ApiService";


export default /*#__PURE__*/_defineComponent({
  __name: 'LestextesDetails',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const publication = ref<any>(null);
const loading = ref(true);

const loadPublication = async () => {
  try {
    const { data } = await ApiService.get(`/publications/${route.params.id}`);
    publication.value = data.data;
  } catch (error) {
    console.error("Erreur chargement publication :", error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  loadPublication();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-outline-secondary mb-4",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
    }, " ← Retour "),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Chargement... "))
      : (publication.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(publication.value.titre), 1),
            _createElementVNode("p", _hoisted_5, " Année : " + _toDisplayString(publication.value.annepublication), 1),
            _createElementVNode("p", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(publication.value.auteur), 1)
            ]),
            _createElementVNode("div", {
              class: "contenu",
              innerHTML: publication.value.contenu,
              style: {"white-space":"pre-line"}
            }, null, 8, _hoisted_8)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, " Publication introuvable "))
  ]))
}
}

})